import { Helmet } from 'react-helmet-async'

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Proof of Reserves Auditor</title>
        <meta name="description" content="Learn about our team of certified auditors and our mission to bring transparency to the digital asset industry." />
      </Helmet>

      <div className="about-page">
        <section className="relative section-padding bg-gradient-to-br from-primary to-primary-800 text-white">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="/whoweare.jpg"
              alt="Who We Are Background"
              className="w-full h-full object-cover"
            />
            {/* Dark overlay for text readability */}
            <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          </div>
          <div className="container-custom text-center relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">About Us</h1>
            <p className="text-xl text-gray-200 max-w-3xl mx-auto">
              Independent, certified auditors bringing transparency to the cryptocurrency industry
            </p>
          </div>
        </section>

        <section className="section-padding bg-white">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto">
              <h2 className="section-title">Our Mission</h2>
              <p className="text-lg text-gray-600 mb-6">
                We provide independent proof of reserves audits that verify cryptocurrency platforms have the assets they claim. Our team of CPA-certified auditors combines traditional accounting expertise with deep blockchain knowledge to deliver transparent, reliable verification services.
              </p>
              
              <h2 className="section-title mt-12">Our Team</h2>
              <p className="text-lg text-gray-600 mb-6">
                Our auditors bring decades of combined experience in traditional finance, accounting, and blockchain technology. Every audit is conducted to the highest professional standards.
              </p>

              <h2 className="section-title mt-12">Why Choose Us</h2>
              <ul className="list-disc list-inside text-lg text-gray-600 space-y-2">
                <li>CPA-certified auditors with blockchain expertise</li>
                <li>Industry-standard methodologies and best practices</li>
                <li>Cutting-edge verification tools and technology</li>
                <li>Fast turnaround times without sacrificing quality</li>
                <li>Trusted by leading platforms worldwide</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default About